// 模拟机详情
export default {
    simulator: '模拟机',
    initialPosition: '初始位置',
    altitude: '海拔',
    startUp: '启动',
    remainingTime: '剩余时间',
    minute: '分钟',
    offline: '下线',
    startSuccess: '启动成功',
    stoppedSuccess: '停止成功',
    mapPicking: '地图拾取',
    endPickup: '结束拾取',
    tip_FEPI: '格式错误，请重新输入',
    tip_PELng: '请输入经度',
    tip_PELat: '请输入纬度',
    tip_PEA: '请输入海拔',
    tip_PETA: '请输入地址',
    tip_CFTA: '查询不到该地址',
    tip_EBWR: '例：北京市丰台区北京西站',
}